import { KEY_EVENT_EDITOR } from '@udecode/plate-common';

export const EVENT_EDITOR_PLUGIN_KEY = KEY_EVENT_EDITOR;

export const FOCUS_EDITOR_EVENT = 'uui-focus-editor';
export const BLUR_EDITOR_EVENT = 'uui-blur-editor';
